import * as React from 'react';

import { Col, Popover, Row } from 'antd';
import { PopoverPlacement } from 'farmhub-ui-core';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { RootState } from 'app';
import { DotColor } from 'components';

interface SelectColorProps {
  color: any;
  setColor: (e: any) => void;
}

const SelectColor = ({ color, setColor }: SelectColorProps): JSX.Element => {
  const colors = useSelector((state: RootState) => state.color.list);
  const [isVisible, setIsVisible] = React.useState<boolean>(false);

  const content = () => (
    <WrapperColors>
      <Row gutter={[8, 8]}>
        {colors.map((item: any) => (
          <Col
            key={item.id}
            span={4}
            onClick={() => {
              setColor(item.code);
              setIsVisible(false);
            }}
          >
            <DotColor color={item.code} size="24px" />
          </Col>
        ))}
      </Row>
    </WrapperColors>
  );

  React.useEffect(() => {
    if (isVisible) {
      setColor(colors[0].code);
    }
  }, [colors, isVisible, setColor]);

  return (
    <Popover
      arrowPointAtCenter
      content={content}
      placement={PopoverPlacement.RightTop}
      trigger="click"
      visible={isVisible}
      onVisibleChange={() => setIsVisible(!isVisible)} // TODO: update in core
    >
      <DotColor color={color} size="16px" />
    </Popover>
  );
};

export default SelectColor;

const WrapperColors = styled.div`
  width: 200px;
  height: auto;
`;
